import { FC, useCallback, useEffect, useMemo, useState } from 'react';

import { Subtitle } from '../../../types/subtitles';
import { BaseCustomComponentVideo } from '../add-element';
import * as ButtonsStyled from '../common-menu-item.styles';
import { Menu } from '../menu/menu';

import * as Styled from './subtitles-button.styles';

type Props = BaseCustomComponentVideo & {
  subtitles?: Subtitle[];
};
export const SubtitlesButton: FC<Props> = ({ subtitles = [], player }) => {
  const [selected, setSelected] = useState<string>('none');

  const changeSubtitle = useCallback(
    (subtitleId: string): void => {
      const tracks = player.textTracks();

      const tracksArray = tracks.tracks_;

      tracksArray.map((track) => {
        if (track.id === subtitleId) track.mode = 'showing';
        else track.mode = 'hidden';
      });

      setSelected(subtitleId);
    },
    [player, setSelected]
  );

  useEffect(() => {
    subtitles.map((subtitle) => {
      player.addRemoteTextTrack(
        {
          kind: 'captions',
          label: subtitle.label,
          src: subtitle.sources?.find((s: any) => s.type === 'WEBVTT')?.source,
          mode: 'hidden',
          id: subtitle.id,
        },
        false
      );
    });
  }, [subtitles, player]);

  useEffect(() => {
    if (player.muted()) {
      const defaultIndex = subtitles.findIndex(
        (sub) => sub.label.toLowerCase() === 'de'
      );

      if (defaultIndex >= 0) {
        changeSubtitle(subtitles[defaultIndex].id);
      }
    }
  }, []);

  const subtitleWithNone = useMemo(
    () => [
      ...subtitles,
      {
        id: 'none',
        label: 'none',
      },
    ],
    [subtitles]
  );

  if (subtitles.length === 0) {
    return null;
  }

  return (
    <Menu player={player} button={() => <Styled.Button aria-hidden="true" />}>
      {(hideMenu) =>
        subtitleWithNone.map((subtitle) => (
          <ButtonsStyled.ItemButton
            key={subtitle.id}
            $selected={selected === subtitle.id}
            onClick={() => {
              hideMenu();
              changeSubtitle(subtitle.id);
            }}
          >
            {subtitle.label}
          </ButtonsStyled.ItemButton>
        ))
      }
    </Menu>
  );
};
